import { Alert } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { ExactClientEventStatus } from '../../../common/enums/exactClientEventStatus';
import { fetchJson } from '../../store/fetch';
import { translateKey } from '../../translate';

interface IExactClientEventProgressProps {
    exactClientEventId: string;
}

export function ExactClientEventProgress(props: IExactClientEventProgressProps) {
    const [pollingTimeout, setPollingTimeout] = useState<number>();
    const [message, setMessage] = useState<string>();
    const [appearance, setAppearance] = useState<'info' | 'success' | 'warning'>('info');

    useEffect(() => {
        if (props.exactClientEventId) {
            setMessage('Soon we will send the exported data to Exact...');
            poll();
        }
    }, [props.exactClientEventId]);

    async function poll() {
        window.clearTimeout(pollingTimeout);
        try {
            const res = await fetchJson(`/api/exact/exactClientEvents/${props.exactClientEventId}`, 'GET');
            switch (res.json.status) {
                case ExactClientEventStatus.declared:
                    setMessage(translateKey('exact.exportDeclared'));
                    setAppearance('info');
                    setPollingTimeout(
                        window.setTimeout(async () => {
                            await poll();
                        }, 1000)
                    );
                    break;
                case ExactClientEventStatus.started:
                    setMessage(translateKey('exact.exportInProgress', res.json.progressPercentage));
                    setAppearance('info');
                    setPollingTimeout(
                        window.setTimeout(async () => {
                            await poll();
                        }, 1000)
                    );
                    break;
                case ExactClientEventStatus.failure:
                    setMessage(translateKey('exact.exportFailedGeneric'));
                    setAppearance('warning');
                    break;
                case ExactClientEventStatus.success:
                    setMessage(translateKey('exact.exportSuccess'));
                    setAppearance('success');
                    break;
                default:
                    return;
            }
        } catch (e) {
            window.clearTimeout(pollingTimeout);
        }
    }

    return <Alert appearance={appearance}>{message}</Alert>;
}
